import styles from "./page-title.module.css"

// Page title component. Takes several props and renders a title.
// REQUIRED: title
// OPTIONAL: author | date | subtitle | type
// Type prop distinguishes between blog post titles, and typical titles
export function PageTitle(
  props: React.ComponentProps<"div"> & {
    title: string
    author?: string
    date?: string
    subtitle?: string
    type?: "blog" | "page"
  }
) {
  const moreThanTitle = props.author || props.date || props.subtitle

  return (
    <div className={styles["container"]}>
      {props.type === "blog" ?
        <h2>{props.title}</h2>
      : <h1>{props.title}</h1>}
      {moreThanTitle && (
        <div className={styles["secondaryInfo"]}>
          {props.subtitle ?
            <h3 className={styles["subtitle"]}>{props.subtitle}</h3>
          : null}
          {props.author ?
            <h4 className={styles["author"]}>
              <strong>{props.author}</strong>
            </h4>
          : null}
          {props.date ?
            <span className={styles["date"]}>{props.date}</span>
          : null}
        </div>
      )}
    </div>
  )
}
